/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_C21Inputs */

const en_cv_extract_form_enum_c21 = /** @type {(inputs: Cv_Extract_Form_Enum_C21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C2 - Proficient`)
};

const de_cv_extract_form_enum_c21 = /** @type {(inputs: Cv_Extract_Form_Enum_C21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C2 - Annähernd muttersprachliche Kenntnisse`)
};

/**
* | output |
* | --- |
* | "C2 - Proficient" |
*
* @param {Cv_Extract_Form_Enum_C21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_c21 = /** @type {((inputs?: Cv_Extract_Form_Enum_C21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_C21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_c21(inputs)
	return en_cv_extract_form_enum_c21(inputs)
});
export { cv_extract_form_enum_c21 as "cv_extract_form_enum_C2" }